// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var ParticleInfo$PdgLookup = require("../../lib/ParticleInfo.bs.js");

var latexText = Css.style({
      hd: Css.display("initial"),
      tl: {
        hd: Css.fontSize({
              NAME: "rem",
              VAL: 5
            }),
        tl: {
          hd: Css.color(Css.hex("1a202c")),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  latexText: latexText
};

function LatexName(props) {
  var rawLatex = ParticleInfo$PdgLookup.getRawLatex(props.particle);
  return JsxRuntime.jsx("div", {
              className: latexText,
              title: rawLatex,
              dangerouslySetInnerHTML: {
                __html: katex.renderToString(rawLatex)
              }
            });
}

var make = LatexName;

exports.Styles = Styles;
exports.make = make;
/* latexText Not a pure module */
